export const LOGOUT_ARTIST = "LOGOUT_ARTIST";
export const LOGOUT_SUBSCRIBER = "LOGOUT_SUBSCRIBER";